<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
		</el-tooltip>
		<p class="error-msg" v-show="uploadError">上传失败!</p>
		<div v-if="previewSrc === ''" class="banner-add el-icon-plus" @mouseover="emptyImgMouseOver" @mouseout="emptyImgMouseOut">
			<div class="empty-img-btn" v-show="emptyBtnShow">
				<el-button class="upload-offline-btn" type="primary" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
			</div>
		</div>
		<div v-else class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<w-image :src="previewSrc" alt="" class="img-preview"></w-image>
			<div class="img-btn" v-show="activeFlag">
				<el-button class="upload-btn" type="primary" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
				<el-button class="delete-btn" type="danger" @click="deleteClick"><i class="el-icon-delete"></i></el-button>
				<el-button class="search-btn" type="danger" @click="previewClick"><i class="el-icon-search"></i></el-button>
			</div>
		</div>
		<input type="file" ref="file" id="file" accept="image/png,image/jpeg,image/jpg,image/gif" v-show="false" @change="getFile">
		<el-dialog title="查看图片" class="dialog-title" :visible.sync="showImgModal" width='400px' :close-on-click-modal="false">
			<div style="text-align:center;">
				<w-image :src="previewSrc" style="width: 350px;display:inline-block;"></w-image>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'imgUpload',
	props: {
		imgSrc: {
			type: String,
			default: ''
		},
		imgId: {
			type: String,
			default: '0'
		},
		seqnum: Number
	},
	data () {
		return {
			uploadError: false,
			previewSrc: '',
			uploadType: new RegExp(/image\/png|image\/jpg|image\/jpeg/),
			uploadTypeText: 'png,jpg,jpeg',
			uploadSize: 1,
			activeFlag: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null,
			fileFiles: '',
			emptyBtnShow: false,
			showImgModal: false
		}
	},
	created () {
		this.previewSrc = this.imgSrc
	},
	watch: {
		imgSrc (val) {
			this.previewSrc = val
			this.$refs.file.value = ''
			this.uploadError = false
		}
	},
	methods: {
		emptyImgMouseOver () {
			this.emptyBtnShow = true
		},
		emptyImgMouseOut () {
			this.emptyBtnShow = false
		},
		imgMouseOver () {
			this.activeFlag = true
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			this.$refs.file.click()
		},
		getFile (e) {
			this.uploadError = false
			this.fileFiles = this.$refs.file.files[0]
			let files = e.target.files[0]
			let type = files.type
			let size = files.size / 1024 / 1024
			if (!this.uploadType.test(type)) {
				this.$message.error(`上传图片只支持${this.uploadTypeText}格式!`)
				return false
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传图片大小不能超过${this.uploadSize}M!`)
				this.$refs.file.value = ''
				this.previewSrc = ''
				this.$emit('update:imgSrc', '')
				this.$emit('update:hasFile', '0')
				this.uploadError = false
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let formData = new FormData()
			formData.append('extension', this.$refs.file.files[0].type.split('/')[1])
			formData.append('file', this.fileFiles)
			this.$store.dispatch('requestFilePost', {
				url: `${this.$fxBaseApi.urlQNV}/shop/upload/pic/temp`,
				data: formData
			}).then(res => {
				if (res.result) {
					this.showTooltip()
					this.$emit('update:imgSrc', res.data)
					this.$emit('imgChange')
					this.uploadError = false
				} else {
					this.$message.error('上传图片失败')
					this.uploadError = true
				}
			}).catch(() => {
				this.uploadError = true
			})
		},
		previewClick () {
			this.showImgModal = true
		},
		deleteClick () {
			this.$refs.file.value = ''
			this.previewSrc = ''
			this.$emit('update:imgSrc', '')
			this.$emit('imgChange')
			this.uploadError = false
		},
		showTooltip () {
			this.tooltipShow = true
			if (this.tooltipTimer) {
				clearTimeout(this.tooltipTimer)
			}
			this.tooltipTimer = setTimeout(() => {
				this.tooltipShow = false
			}, 1500)
		}
	}
}
</script>
<style lang="stylus" scoped>
/deep/.el-loading-mask {
	height: 80px
	margin-top: 20px
	border-radius: 6px;
}
.banner-upload {
	width: 80px;
	height: 80px;
	border-radius: 6px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	margin:0 10px
	float left
	.error-msg {
		color:red
		position:absolute
		top:0
		left:0
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box
		width: 80px;
		height: 80px;
		line-height: 80px;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		.empty-img-btn {
			position: absolute
			top:0px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
			.el-button {
				padding: 4px
				text-align center
				position absolute
			}
			.upload-offline-btn {
				top: 27px;
				left: 27px;
			}
			.upload-online-btn {
				top: 24px;
				right: 10px;
			}
		}
	}
	.img-preview-block {
		position:relative
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		.img-preview {
			width:100%
		}
		.img-btn {
			position: absolute
			top:0px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
			.el-button {
				padding: 4px
				text-align center
				position absolute
			}
			.upload-btn {
				top: 14px;
				left: 10px;
			}
			.delete-btn {
				top: 14px;
				right: 10px;
			}
			.search-btn {
				bottom 8px
				left 18px
			}
		}
	}
}
</style>
